import React from 'react';
import PropTypes from 'prop-types';
import InfoSelectField from 'ntnu-react/material/InfoSelectField';
import MenuItem from 'material-ui/MenuItem';

import info from '../constants/infotexts.json';
import choices from '../constants/choices.json';

const { Benefit } = choices;

const styles = {
        flex: {
            flex: 1,
            marginBottom: '2em',
        },
    };


class BenefitTab extends React.Component {
    shouldComponentUpdate(nextProps) {
        const old = this.props.data;
        const next = nextProps.data;

        return old.Benefit1 !== next.Benefit1
        || old.Benefit2 !== next.Benefit2
        || old.Benefit3 !== next.Benefit3
        || old.Benefit4 !== next.Benefit4
        || old.Benefit5 !== next.Benefit5;
    }

    handleSelectChange = (field) => {
        return (e, index, value) => {
            this.props.fieldChange(field, value, true);
        };
    }

    render() {
        const { data } = this.props;

        return (
            <section style={{
                display: 'flex',
                flexDirection: 'column',
            }}>
                <InfoSelectField
                    floatingLabelText="Antall berørte sluttbrukere"
                    infoText={info.benefit.Benefit1}
                    value={data.Benefit1}
                    onChange={this.handleSelectChange('Benefit1')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Benefit.Benefit1.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Benefit1 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="Prosessforbedring"
                    infoText={info.benefit.Benefit2}
                    value={data.Benefit2}
                    onChange={this.handleSelectChange('Benefit2')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Benefit.Benefit2.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Benefit2 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="Nytte for fellesskapet"
                    infoText={info.benefit.Benefit3}
                    value={data.Benefit3}
                    onChange={this.handleSelectChange('Benefit3')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Benefit.Benefit3.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Benfit3 === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoSelectField
                    floatingLabelText="Tjenesteforbedring"
                    infoText={info.benefit.Benefit4}
                    value={data.Benefit4}
                    onChange={this.handleSelectChange('Benefit4')}
                    wrapStyle={styles.flex}
                    disabled={this.props.disabled}
                >
                    {Benefit.Benefit4.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.Benefit4 === item.key}
                        />
                    ))}
                </InfoSelectField>
            </section>
        );
    }
}

BenefitTab.propTypes = {
    data: PropTypes.object.isRequired,
    fieldChange: PropTypes.func.isRequired,
    style: PropTypes.object,
    disabled: PropTypes.bool,
};

export default BenefitTab;



// WEBPACK FOOTER //
// ./src/components/BenefitTab.js